import { render, staticRenderFns } from "./re.vue?vue&type=template&id=38c505b6"
import script from "./re.vue?vue&type=script&lang=js"
export * from "./re.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports